import * as RESOURCES from '@constants/resources';
import * as CONST from '@constants/variables';

export const authorizationObject = {
    [RESOURCES.ENCODING_JOB_PROFILE]: CONST.SECURITY_PRIVILEGES_READ,
};
